var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBgShape4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1036,
    viewBox: "0 0 1920 1036",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_638_4459",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1921,
    height: 1036
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 17.2093C0 7.70485 5.65535 0 12.6316 0H1907.37C1914.34 0 1920 7.70487 1920 17.2093V1018.79C1920 1028.3 1914.34 1036 1907.37 1036H12.6315C5.6553 1036 0 1028.3 0 1018.79V17.2093Z",
    fill: "#1C1C1C"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_638_4459)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1183.84 833.103C1183.84 833.103 1449.14 617.708 1814.57 619.917C2180.03 622.115 1626.78 1319.23 1626.78 1319.23C1626.8 1319.21 1657.45 1279.86 1657.45 1279.86",
    stroke: "#F9F9F9",
    strokeOpacity: 0.06,
    strokeWidth: 0.877694
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1198.25 816.983C1198.25 816.983 1461.41 594.397 1827.33 599.285C2193.24 604.173 1647.22 1326.81 1647.22 1326.81C1647.23 1326.79 1677.47 1286 1677.47 1286",
    stroke: "#F9F9F9",
    strokeOpacity: 0.06,
    strokeWidth: 0.877694
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1213.04 800.359C1213.04 800.359 1474.11 570.559 1840.49 578.139C2206.87 585.723 1668.05 1333.86 1668.05 1333.86C1668.06 1333.83 1697.89 1291.6 1697.89 1291.6",
    stroke: "#F9F9F9",
    strokeOpacity: 0.06,
    strokeWidth: 0.877694
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1228.41 782.989C1228.41 782.989 1487.38 545.974 1854.25 556.244C2221.13 566.519 1689.46 1340.16 1689.46 1340.16C1689.47 1340.13 1718.9 1296.45 1718.9 1296.45",
    stroke: "#F9F9F9",
    strokeOpacity: 0.06,
    strokeWidth: 0.877694
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1243.84 765.531C1243.84 765.531 1500.73 521.321 1868.09 534.279C2235.46 547.238 1710.93 1346.39 1710.93 1346.39C1710.94 1346.37 1739.97 1301.24 1739.97 1301.24",
    stroke: "#F9F9F9",
    strokeOpacity: 0.06,
    strokeWidth: 0.877694
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1259.36 747.984C1259.36 747.984 1514.18 496.554 1882.07 512.199C2249.96 527.849 1732.53 1352.52 1732.53 1352.52C1732.54 1352.49 1761.16 1305.92 1761.16 1305.92",
    stroke: "#F9F9F9",
    strokeOpacity: 0.06,
    strokeWidth: 0.877694
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1274.92 730.337C1274.92 730.337 1527.7 471.683 1896.13 490.022C2264.57 508.363 1754.21 1358.55 1754.21 1358.55C1754.22 1358.53 1782.44 1310.51 1782.44 1310.51",
    stroke: "#F9F9F9",
    strokeOpacity: 0.06,
    strokeWidth: 0.877694
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1290.55 712.616C1290.55 712.616 1541.29 446.737 1910.26 467.784C2279.24 488.808 1775.93 1364.53 1775.93 1364.53C1775.94 1364.51 1803.77 1315.04 1803.77 1315.04",
    stroke: "#F9F9F9",
    strokeOpacity: 0.06,
    strokeWidth: 0.877694
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1702.69 457.266C1702.69 457.266 1262.93 591.266 1149.72 908.71C1036.51 1226.13 2362.22 1056.86 2362.22 1056.86L2287.53 1065.91",
    stroke: "#F9F9F9",
    strokeOpacity: 0.06,
    strokeWidth: 0.877694
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1723.17 442.008C1723.17 442.008 1291.07 579.127 1175.16 895.219C1059.24 1211.31 2358 1030.87 2358 1030.87L2284.84 1040.56",
    stroke: "#F9F9F9",
    strokeOpacity: 0.06,
    strokeWidth: 0.877694
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1743.81 424.181C1743.81 424.181 1319.38 564.415 1200.78 879.155C1082.17 1193.89 2353.94 1002.31 2353.94 1002.31L2282.31 1012.63",
    stroke: "#F9F9F9",
    strokeOpacity: 0.06,
    strokeWidth: 0.877694
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1764.66 406.175C1764.66 406.175 1347.89 549.522 1226.59 862.93C1105.29 1176.34 2350.09 973.599 2350.09 973.599L2279.98 984.55",
    stroke: "#F9F9F9",
    strokeOpacity: 0.06,
    strokeWidth: 0.877694
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1785.68 387.984C1785.68 387.984 1376.58 534.42 1252.61 846.496C1128.63 1158.55 2346.44 944.684 2346.44 944.684L2277.86 956.265",
    stroke: "#F9F9F9",
    strokeOpacity: 0.06,
    strokeWidth: 0.877694
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1806.89 369.713C1806.89 369.713 1405.46 519.256 1278.82 829.978C1152.18 1140.7 2342.99 915.689 2342.99 915.689L2275.95 927.902",
    stroke: "#F9F9F9",
    strokeOpacity: 0.06,
    strokeWidth: 0.877694
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1828.93 351.93C1828.93 351.93 1435.18 504.578 1305.88 813.945C1176.58 1123.31 2340.43 887.188 2340.43 887.188L2274.91 900.03",
    stroke: "#F9F9F9",
    strokeOpacity: 0.06,
    strokeWidth: 0.877694
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1851.29 334.209C1851.29 334.209 1465.21 489.96 1333.27 797.971C1201.31 1106 2338.17 858.772 2338.17 858.772L2274.17 872.245",
    stroke: "#F9F9F9",
    strokeOpacity: 0.06,
    strokeWidth: 0.877694
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1875.02 317.544C1875.02 317.544 1496.63 476.373 1362.03 783.072C1227.44 1089.75 2337.3 831.416 2337.3 831.416L2274.83 845.517",
    stroke: "#F9F9F9",
    strokeOpacity: 0.06,
    strokeWidth: 0.877694
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1899.81 301.668C1899.81 301.668 1529.1 463.594 1391.88 768.936C1254.66 1074.28 2337.52 804.832 2337.52 804.832L2276.59 819.563",
    stroke: "#F9F9F9",
    strokeOpacity: 0.06,
    strokeWidth: 0.877694
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1925.6 286.538C1925.6 286.538 1562.58 451.559 1422.75 755.544C1282.92 1059.53 2338.78 778.998 2338.78 778.998L2279.37 794.358",
    stroke: "#F9F9F9",
    strokeOpacity: 0.06,
    strokeWidth: 0.877694
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1952.29 272.119C1952.29 272.119 1596.97 440.232 1454.54 742.86C1312.1 1045.51 2340.98 753.888 2340.98 753.888L2283.1 769.873",
    stroke: "#F9F9F9",
    strokeOpacity: 0.06,
    strokeWidth: 0.877694
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1979.11 258.534C1979.11 258.534 1631.5 429.714 1486.47 731.027C1341.45 1032.32 2343.3 729.651 2343.3 729.651L2286.96 746.265",
    stroke: "#F9F9F9",
    strokeOpacity: 0.06,
    strokeWidth: 0.877694
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2005.95 245.704C2005.95 245.704 1666.04 419.971 1518.45 719.924C1370.85 1019.88 2345.7 706.131 2345.7 706.131L2290.88 723.371",
    stroke: "#F9F9F9",
    strokeOpacity: 0.06,
    strokeWidth: 0.877694
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2030.96 234.031C2030.96 234.031 1698.76 411.382 1548.62 709.975C1398.47 1008.57 2346.3 683.773 2346.3 683.773L2293.01 701.64",
    stroke: "#F9F9F9",
    strokeOpacity: 0.06,
    strokeWidth: 0.877694
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2054.37 223.402C2054.37 223.402 1729.9 403.812 1577.21 701.066C1424.53 998.321 2345.36 662.47 2345.36 662.47L2293.6 680.963",
    stroke: "#F9F9F9",
    strokeOpacity: 0.06,
    strokeWidth: 0.877694
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2076.28 213.701C2076.28 213.701 1759.53 397.188 1604.34 693.082C1449.15 988.977 2342.94 642.094 2342.94 642.094L2292.71 661.213",
    stroke: "#F9F9F9",
    strokeOpacity: 0.06,
    strokeWidth: 0.877694
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2096.82 204.842C2096.82 204.842 1787.8 391.404 1630.11 685.959C1472.43 980.515 2339.18 622.61 2339.18 622.61C2339.19 622.614 2290.48 642.354 2290.48 642.354",
    stroke: "#F9F9F9",
    strokeOpacity: 0.06,
    strokeWidth: 0.877694
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgShape4);
export default __webpack_public_path__ + "static/media/bg-shape-4.0908b83a14594fedb7b25a2908d237c3.svg";
export { ForwardRef as ReactComponent };